import SurveyFormat from './surveyFormatEnum';

export const extrapolateSurveyData = survey => {
  if (Object.entries(survey).length === 0) {
    return {};
  }

  return {
    isAutoScroll: survey.format === SurveyFormat.OQAAT,
    isFooterEnabled: survey.design.footer.enabled,
    isQuestionNumberingEnabled: survey.design.questionNumbering.enabled,
    isSurveyTitleEnabled: survey.design.surveyTitle.enabled,
    langCode: survey.language?.code,
    logo: survey.design.logo,
    questions: survey.questionsQM?.items ?? [],
    showPageTitles: survey.design.showPageTitles,
    showRequiredQuestionAsterisks: survey.design.showRequiredQuestionAsterisks,
    surveyPages: survey.pages?.items || [],
    surveyTitle: survey.title,
    surveyTitleAlignment: survey.design.surveyTitle.horizontalAlignment,
    surveyTitleHTML: survey.titleHTML,
    themeVersion: survey?.design.theme.version,
    totalQuestionsCount: survey?.questionCount,
  };
};

export default extrapolateSurveyData;
